<!-- 发送验证码组件 -->
<template id="send_code">
  <div class="s-form-row validate-code">
    <label class="s-form-label">
      请填写{{ type == 'email' ? '邮箱验证码' : '手机校验码' }}：
    </label>
    <div class="s-form-info">
      <p>
          <!-- :class="{'error': codeError}" 2018 1106 处理红色提示框 -->
        <input :placeholder="'请输入'+(type == 'email' ? '邮箱验证码' : '手机校验码')"  v-model="code" @input="validateCode" class="form-code"/>
        <button type="button" class="s-button form-get-code" @click="getCode" :disabled="isDisabled">获取{{ type == 'email' ? '邮箱验证码' : '手机校验码' }}</button>
      </p>
      <p class="s-form-subtext" v-show="showTips">
        验证码已发出，请注意
        <span v-if="type == 'email'">查收邮箱</span>
        <!-- <a :href="domain" class="blue" v-if="type == 'email'" target="_blank">查收邮箱</a> -->
        <span v-else>查收短信</span>
        ，如果没有收到，你可以在<span class="orange">{{ count }}</span>秒后要求系统重新发送
      </p>
    </div>
  </div>
</template>

<script>
  export default {
    props: ['type', 'request', 'is_new', 'pwd_type', "modify_type"],
    data() {
      return {
        code: '',             //用户输入的验证码
        codeError: false,
        isDisabled: false,    //是否禁用获取验证码按钮
        limit: 60,            //获取验证码时间间隔
        count: 0,             //倒计时临时变量
        countFn: null,        //倒计时函数
        showTips: false,      //是否显示提示
        domain: ''            //邮箱的域名
      }
    },
    computed: {
      /*
       ** 本地化父组件传入的参数
       ** @params hasError {Boolean} 当前传入的参数是否合法
       ** @params 父组件决定的其它参数
       */
      req() {
          return this.request;
      }
    },
    methods: {
      /*
       ** 验证code
       */
      validateCode() {
        let validate = this.$root.config.validateEmpty(this.code);

        if(validate){
          this.codeError = false;
          return false;
        }
        else{
          this.codeError = true;
          return true;
        }
      },
      /*
       ** 获取验证码
       */
      getCode() {
        let url, req;
        switch(this.type) {
          case 'email':
            url = 'auth/email/send/';
            break;
          case 'phone':
          case 'pwd':
            url = 'auth/sms/send/';
            break;
        }

        this.isDisabled = true;
        this.showTips = true;

        if(this.type == 'pwd'){
          this.req.phone = this.req.pwd;
          delete this.req.pwd;
        }

        //请求是否需要带手机号/邮箱
        if(this.is_new){
          req = this.req;
          if (this.type == "email") {
            req.action = "bind_email";
          }else if(this.type == "phone") {
            req.action = "register";
          }
        }
        else{
          req = {};
          switch(this.type) {
            case 'email':
              if (this.modify_type == '邮箱') {
                req.action = 'chg_email';
              }else if (this.modify_type == '手机') {
                req.action = 'chg_phone';
              }
              break;
            case 'phone':
              if (this.modify_type == '邮箱') {
                req.action = 'chg_email';
              }else if (this.modify_type == '手机') {
                req.action = 'chg_phone';
              }
              break;
            case 'pwd':
              if (this.pwd_type == "secondary") {
                req.action = 'chg_second';
              }else if(this.pwd_type === "trade"){
                req.action = 'chg_trade';
              }
              break;
          }
        }

        axios.post(myUrl + url, qs.stringify(req)).then(response => {
          let res = response.data;

          if(res.result){
            this.type == 'email' ? this.domain = res.domain : '';
          }
          else{
            this.count = 0;
            this.$emit('errorResult', res);
          }
        }, reject => {
          this.$emit('errorResult', reject);
        })

        this._countdown();
      },
      /*
       ** 倒计时
       */
      _countdown() {
        this.count = this.limit;

        this.countFn = () => {
          window.setTimeout(() => {
            if(this.count == 0){
              this.isDisabled = false;
              this.showTips = false;
            }
            else{
              this.count--;
              this.countFn();
            }
          }, 1000);
        }

        this.countFn();
      }
    },
    updated() {
      // this.codeError = false;
    }
  }
</script>

<style media="screen" scoped lang="scss">
  .s-form-subtext{
    margin-top: 15px;
  }
  .form-code{
    width: 215px;
    vertical-align: top;
    margin-right: 13px;
  }
  .form-get-code{
    width: 128px;
  }
  .validate-code{
    .s-form-info{
      height: auto;
      line-height: inherit;
    }
  }
</style>



// WEBPACK FOOTER //
// send_code.vue?5a37d8fd